import { Link } from 'react-router'
import IconSVG from 'svg-inline-react'

import styles from './style.styl'

function CampaignIconLink({ campaign }) {
  return (
    <Link to={`/campaigns/${ campaign.id }`} className={`${styles.LinkIcon} flex-center`}>
      <IconSVG
        src={require('!svg-inline?removeTags=true!images/svg/growth-slope-graph.svg')}
        style={{ width: 16, height: 11 }}
      />
    </Link>
  )
}

export default CampaignIconLink



// WEBPACK FOOTER //
// ./src/scripts/components/customer/TimeLine/CampaignIconLink/index.js